import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '../core/services/authentication.service';
import { Subscription } from 'rxjs/Subscription';
import { User } from '../core/models/user.model';
import { UsersService } from '../core/services/users.service';

@Component({
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit, OnDestroy {
  error = false;
  loading = false;
  loggedIn = false;
  currentUser: User = null;
  password = '';
  username = '';

  private subscriptions: Subscription[] = [];

  constructor(
    private authenticationService: AuthenticationService,
    private usersService: UsersService,
    private route: ActivatedRoute,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit() {
    if (this.route.snapshot.queryParams['logout'] === '1') {
      this.logout();
    } else {
      this.loggedIn = this.authenticationService.isLoggedIn;
      if (this.loggedIn) {
        this.subscriptions.push(this.usersService.currentUser.subscribe(user => this.currentUser = user));
      }
    }

    this.changeDetectorRef.detectChanges();
    if (this.loggedIn) {
      this.validationForUser();
    }
    else
      this.logout();
  }

  onKeyDown(event: any) {
    if (event.keyCode === 13) {
      this.login();
    }
  }

  login() {
    let loginresult = false;
    this.loading = true;

    this.subscriptions.push(this.authenticationService.login(this.username, this.password)
      .mergeMap(result => {
        loginresult = result;
        return this.route.queryParams;
      })
      .map(qp => qp['redirectTo'])
      .subscribe(redirectTo => {
        if (loginresult === true) {
          this.validationForUser();
        } else {
          this.error = true;
          this.loading = false;
        }
      }
      ));
  }

  logout() {
    this.authenticationService.logout();
    this.currentUser = null;
    this.loggedIn = false;
    this.router.navigate(['login'], { queryParams: {} });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  validationForUser() {
    this.subscriptions.push(this.usersService.currentUser.subscribe(user => {
      this.currentUser = user
      this.router.navigate(['/index'], { queryParams: {} });
    }))
  }

  restorePassword() {
    this.router.navigate(['/nologin/restaurarSolicitud'], { queryParams: {}, skipLocationChange: true });
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/login/login.component.ts